import React from "react";
export const Paragraph = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("p", {
    className: className,
    ref: ref
  }, children);
});